import React from "react";
import { connect } from "react-redux";

import {
  getStudentPaymentIDList,
  getSchoolByStudentID,
  getStudentTotalCreditAmountToPay,
  getGoToPaymentID
} from "state/school_money/selectors";
import { clearGoToPayment } from "state/school_money/actions";

import ScrollableList from "components/ScrollableList";
import List from "components/List";
import PlaceholderCard from "components/school_money/PlaceholderCard";
import Payment from "components/school_money/payments/Payment";
import UnpaidDinnerMoneyPayment from "components/school_money/payments/UnpaidDinnerMoneyPayment";
import UnpaidClubMoneyPayment from "components/school_money/payments/UnpaidClubMoneyPayment";

class StudentPaymentList extends React.Component {

  renderPayments(refChild) {

    const { studentID, paymentIDList, hasUnpaidDinnerMoney, hasUnpaidClubMoney, school } = this.props;

    const placeholder = <PlaceholderCard objectName={"payments"} school={school} />;

    // We have to make sure we only add UnpaidDinnerMoneyPayment if it is
    //   actually going to render. Otherwise, List gets confused and doesn't
    //   render our placeholder.
    let payments = paymentIDList.map(paymentID => <Payment key={paymentID} paymentID={paymentID} innerRef={child => refChild(child, paymentID)} />);
    if (hasUnpaidDinnerMoney) {
      payments = payments.unshift(<UnpaidDinnerMoneyPayment key="dinner" studentID={studentID} innerRef={child => refChild(child, "dinner")} />);
    }
    if (hasUnpaidClubMoney) {
      payments = payments.unshift(<UnpaidClubMoneyPayment key="club" studentID={studentID} innerRef={child => refChild(child, "club")} />);
    }

    return (
      <List placeholder={placeholder}>
        { payments }
      </List>
    )

  }

  render() {
    return (
      <ScrollableList className="payments-list" scrollTargetID={this.props.goToPaymentID} onScroll={this.props.clearGoTo}>
        { refChild => this.renderPayments(refChild) }
      </ScrollableList>
    )
  }

}

export default connect(
  (state, { studentID }) => ({
    paymentIDList: getStudentPaymentIDList(state, studentID),
    school: getSchoolByStudentID(state, studentID),
    hasUnpaidDinnerMoney: getStudentTotalCreditAmountToPay(state, studentID, "dinner_money") < 0,
    hasUnpaidClubMoney: getStudentTotalCreditAmountToPay(state, studentID, "club_extended_services") < 0,
    goToPaymentID: getGoToPaymentID(state)
  }),
  {
    clearGoTo: clearGoToPayment
  }
)(StudentPaymentList);



// WEBPACK FOOTER //
// ./src/components/school_money/payments/StudentPaymentList.js